import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { NavLinkProps } from "react-router";

export const Root = styled(Button, {
  shouldForwardProp: (prop) => prop !== "$isActive",
})<{ $isActive: boolean; to?: NavLinkProps["to"] }>(({ theme, $isActive }) => ({
  minWidth: "auto",
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingTop: theme.spacing(1.25),
  paddingBottom: theme.spacing(1.25),
  textTransform: "none",
  borderRadius: $isActive ? 0 : theme.spacing(1.5),
  borderBottom: $isActive
    ? `0.125rem solid ${theme.palette.text.primary}`
    : "none",
  backgroundColor: "transparent",
  display: "flex",
  alignItems: "center",
  textDecoration: "none",
  color: "inherit",
  "& .MuiButton-startIcon": {
    color: $isActive
      ? theme.palette.text.primary
      : theme.palette.text.secondary,
  },
  "&:hover": {
    backgroundColor: "transparent",
    textDecoration: "none",
  },
  "&.active": {
    borderBottom: `0.125rem solid ${theme.palette.text.primary}`,
  },
}));

export const Text = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$isActive",
})<{ $isActive: boolean }>(({ theme, $isActive }) => ({
  fontWeight: $isActive ? 700 : 500,
  color: $isActive ? theme.palette.text.primary : theme.palette.text.secondary,
}));

export const ArrowIcon = styled(KeyboardArrowDownIcon, {
  shouldForwardProp: (prop) => prop !== "$open",
})<{ $open: boolean }>(({ $open, theme }) => ({
  transform: `rotate(${$open ? -180 : 0}deg)`,
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shorter,
  }),
}));

export const DropdownRoot = styled("div")({
  display: "inline-flex",
  position: "relative",
  verticalAlign: "top",
});
